import en from './en';
import es from './es';
import ja from './ja';
import ru from './ru';

const opcionesIdioma = [
    { label: 'English', value: 'en' },
    { label: 'Español', value: 'es' },
    { label: '日本語', value: 'ja' },
    { label: 'Ruso', value: 'ru' }, 
    // Comenta cualquiera de estas líneas para desactivar idiomas específicos
];

const idiomaHabilitado = (valor) => !['OFF', 'FALSE', '0', 'NO'].includes(
    String(valor ?? 'ON').trim().toUpperCase()
);

const variablesIdioma = {
    en: process.env.VUE_APP_LANGUAGE_EN,
    es: process.env.VUE_APP_LANGUAGE_ES,
    ja: process.env.VUE_APP_LANGUAGE_JA,
    ru: process.env.VUE_APP_LANGUAGE_RU,
};

export const idiomasDisponibles = opcionesIdioma.filter(({ value }) => idiomaHabilitado(variablesIdioma[value]));
if (idiomasDisponibles.length === 0) idiomasDisponibles.push(opcionesIdioma[0]);

const idiomaPredeterminado = idiomasDisponibles.find(({ value }) => value === 'en')?.value
    || idiomasDisponibles[0].value;

const dictionaries = {
    en: {
        'EDICION DE SECUENCIAS DEL BOTON': 'BUTTON SEQUENCE EDITOR',
        'Colecciones': 'Collections', 'Solicitudes Colecciones': 'Collection Requests', 'Raspberrys': 'Raspberry Pis',
        'Buscar Usuarios': 'Find Users', 'Solicitudes Amistad': 'Friend Requests', 'Amistades': 'Friends',
        'OPCIONES': 'OPTIONS', 'Historial Secuencias': 'Sequence History', 'Perfil': 'Profile',
        'Terminos y condiciones': 'Terms and Conditions', 'Select de idiomas aqui': 'Language',
        'Cerrar sesión': 'Log out', 'Algo salio mal': 'Something went wrong',
        'Escriba su correo': 'Enter your email', 'Entre su contraseña': 'Enter your password',
        'Entrar': 'Sign in', 'Registrar': 'Register', 'Recuperar': 'Recover account', 'Bienvenido': 'Welcome',
        'No se recibió respuesta del servidor': 'No response received from the server',
        'Credenciales incorrectas': 'Incorrect credentials', 'No se recibió token de autenticación': 'Authentication token not received',
        'Correo verificado, ya puedes iniciar session.': 'Email verified. You can now sign in.',
        'Registrar': 'Register', 'Entre su Nombre': 'Enter your name', 'Entre su correo': 'Enter your email',
        'Debes validar el captcha': 'Please complete the CAPTCHA', 'Usuario creado, confirma desde tu correo.': 'Account created. Confirm it from your email.',
        'Algo salió mal': 'Something went wrong', 'Error de conexión': 'Connection error',
        'Verificacion Fallida o Vencida.': 'Verification failed or expired.', 'Captcha expirado, verifica nuevamente': 'CAPTCHA expired. Please verify again.',
        'Cambiar Contraseña': 'Change Password', 'Nueva Contraseña': 'New Password', 'Repita Contraseña': 'Repeat Password',
        'Digite una nueva contraseña.': 'Enter a new password.',
        'Enviar': 'Submit', 'Cancelar': 'Cancel', 'Guardar': 'Save', 'Limpiar': 'Clear', 'Cerrar': 'Close',
        'Regresar': 'Back', 'Nombre': 'Name', 'Correo': 'Email', 'Descripcion': 'Description',
        'Mis amigos': 'My Friends', 'Registrar Amistad': 'Add Friend', 'Solicitudes de Amistad': 'Friend Requests',
        'Complete todos los campos requeridos.': 'Complete all required fields.', 'Correo no válido': 'Invalid email address',
        'Nombre demasiado largo': 'Name is too long', 'Error en la petición al servidor': 'Server request failed',
        'Sesión expirada': 'Session expired', 'Solicitud enviada correctamente': 'Request sent successfully',
        'Error al enviar la solicitud': 'Could not send the request', 'Solicitud inválida': 'Invalid request',
        'Solicitud aceptada correctamente': 'Request accepted successfully', 'Error al aceptar la solicitud': 'Could not accept the request',
        'Denunciar': 'Report', '¿Desea denunciar': 'Would you like to report', 'Describa su caso': 'Describe your case',
        'Captura de pantalla': 'Screenshot', 'El registro se denuncio Exitosamente': 'Report submitted successfully',
        'Por el momento no hay informacion': 'There is no information at this time', 'Cargando...': 'Loading...',
        'Iconos para el botón': 'Button icons', 'Al seleccionar un icono, no aparecera el texto del boton.': 'Selecting an icon hides the button text.',
        'Tipo de grupo': 'Group type', 'Cantidad de ciclos': 'Number of cycles', 'Índice Servo': 'Servo index', 'Ángulo': 'Angle',
        'nueva escena': 'New scene', '¿Eliminar escena completa con todos sus momentos?': 'Delete the entire scene and all its steps?',
        'Máximo de 16 servos': 'Maximum of 16 servos', '¿Eliminar servo?': 'Delete servo?',
        'CREACION DE BOTONES': 'CREATE BUTTONS', 'Icono de la secuencia': 'Sequence icon', 'Nombre Secuencia': 'Sequence name',
        '20 caracteres maximo.': '20 characters maximum.', 'Descripcion Secuencia': 'Sequence description',
        'El nombre de la secuencia es obligatorio': 'Sequence name is required', 'Debe seleccionar una colección': 'Select a collection',
        'La descripción es obligatoria': 'Description is required', 'Debe agregar al menos una escena': 'Add at least one scene',
        'Falta tipo en': 'Missing type in', 'Faltan ciclos en': 'Missing cycles in', 'Falta ángulo en': 'Missing angle in',
        'El registro se guardó exitosamente': 'Record saved successfully', 'Hubo un error al guardar la secuencia': 'Could not save the sequence',
        'Error en la petición': 'Request error', 'Mis amigos': 'My Friends', 'MI PERFIL': 'MY PROFILE',
        'EDITAR INFORMACION DE PERFIL': 'EDIT PROFILE INFORMATION', 'Imagen de Perfil': 'Profile picture', 'IMAGEN DE PERFIL': 'PROFILE PICTURE',
        'Seleccione una imagen primero': 'Select an image first', 'La imagen se actualizo Exitosamente': 'Image updated successfully',
        'El registro se guardo Exitosamente': 'Record saved successfully', 'Raspberry': 'Raspberry Pi',
        'Lanzador de botones': 'Button Launcher',
        'Recuperacion de password': 'Password recovery', 'Las contraseñas no coinciden': 'Passwords do not match',
        'Términos aceptados correctamente': 'Terms accepted successfully', 'No se pudieron aceptar los términos': 'Could not accept the terms',
        'Secuencias': 'Sequences', '¿Desea Duplicar este registro?': 'Do you want to duplicate this record?',
        'Duplicar': 'Duplicate', '¿Estás seguro de desactivar esta secuencia?': 'Are you sure you want to deactivate this sequence?',
        'Eliminar': 'Delete', 'La secuencia fue desactivada': 'The sequence was deactivated', 'No se pudo desactivar la secuencia': 'Could not deactivate the sequence',
        'Solicitudes de Compartir Colecciones Recibidas': 'Received Collection Sharing Requests', 'No hay solicitudes de compartir': 'No sharing requests',
        'Aceptar solicitud': 'Accept request', 'Aceptar': 'Accept', 'Rechazar solicitud': 'Decline request', 'Rechazar': 'Decline',
        'Error al cargar las solicitudes': 'Could not load requests', 'Solicitud aceptada correctamente': 'Request accepted successfully',
        'Solicitud rechazada correctamente': 'Request declined successfully', 'Visualizar producto': 'View product',
        'Descripcion general': 'Overview', 'Usos': 'Uses', 'Perfil usuario': 'User profile', 'Observaciones': 'Notes',
        'Cambiar estado': 'Change status', 'No se pudo obtener la información': 'Could not retrieve the information',
        'Error al cargar las amistades.': 'Could not load friends.', 'Amistad eliminada correctamente': 'Friend removed successfully',
        'El registro se guardó exitosamente': 'Record saved successfully', 'Algo salio mal': 'Something went wrong',
        'Idioma': 'Language', 'Inglés': 'English', 'Español': 'Spanish', 'Japonés': 'Japanese', 'Ruso': 'Russian',
        'Nuevo': 'New', 'nuevo': 'New', 'nombre coleccion': 'Collection name', 'idraspberry': 'Raspberry ID',
        'Cargando datos...': 'Loading data...', 'Sin raspberry aun.': 'No Raspberry Pi yet.',
        'nombre_raspberry': 'Raspberry name', 'Descripcion de la Solicitud': 'Request description',
        'Nombre de Raspberry:': 'Raspberry name:', 'Hash del dispositivo:': 'Device hash:',
        '¿Desea deshabilitar este registro?': 'Do you want to disable this record?',
        'Este proceso no se puede desahacer.': 'This action cannot be undone.', 'Solicitud actualizada correctamente': 'Request updated successfully',
        'Registro deshabilitado correctamente': 'Record disabled successfully', 'Hash copiado.': 'Hash copied.',
        'No hay solicitudes de compartir': 'No sharing requests', 'Historial Servos': 'Servo History',
        'Buscar usuarios': 'Find users', 'Registrar Amistad': 'Add Friend', '¿Desea eliminar esta amistad?': 'Do you want to remove this friend?',
        'El registro se guardo Exitosamente': 'Record saved successfully', 'Datos actualizados correctamente': 'Information updated successfully',
        'Buscar': 'Search', 'Acciones': 'Actions', 'Estado': 'Status', 'Fecha': 'Date',
        'Aceptar solicitud': 'Accept request', 'Rechazar solicitud': 'Decline request',
        '¿Eliminar escena completa con todos sus momentos?': 'Delete the entire scene and all its steps?',
        '¿Eliminar servo?': 'Delete servo?', '¿Apagar esta Raspberry?': 'Shut down this Raspberry Pi?',
        '¿Reiniciar esta Raspberry?': 'Restart this Raspberry Pi?', '¿Estás seguro de desactivar esta coleccion?': 'Are you sure you want to disable this collection?',
        '¿Desea denunciar': 'Would you like to report', 'El registro se denuncio Exitosamente': 'Report submitted successfully',
        'Nueva Coleccion': 'New Collection', 'Nombre de la colección': 'Collection name', 'Nombre de colección': 'Collection name',
        'nombre coleccion': 'Collection name', 'Descripción': 'Description', 'Descripcion:': 'Description:',
        'Nueva Amistad': 'New Friend', 'Solicitudes de amistad': 'Friend Requests', 'No hay solicitudes': 'No requests',
        'No se encontraron resultados': 'No results found', 'Buscar usuarios': 'Find users', 'Amistad eliminada correctamente': 'Friend removed successfully',
        'Colección': 'Collection', 'Coleccion': 'Collection', 'Nombre de la secuencia': 'Sequence name',
        'Título': 'Title', 'Titulo': 'Title', 'Versión': 'Version', 'Version': 'Version', 'Descripción:': 'Description:',
        'Cambiar contraseña': 'Change password', 'Nueva contraseña': 'New password', 'Repita contraseña': 'Repeat password',
        'Recuperación de password': 'Password recovery', 'Confirmar': 'Confirm', 'Siguiente': 'Next',
        'El correo es obligatorio': 'Email is required', 'La contraseña es obligatoria': 'Password is required',
        'Contraseña actualizada correctamente': 'Password updated successfully', 'La contraseña se actualizó correctamente': 'Password updated successfully',
        'No se pudo guardar la información': 'Could not save the information', 'El registro no se pudo guardar': 'Could not save the record',
        '¿Desea desactivar este registro?': 'Do you want to deactivate this record?', '¿Está seguro?': 'Are you sure?',
        'Sin resultados': 'No results', 'Página': 'Page', 'de': 'of',
        'MI PERFIL': 'MY PROFILE', 'MIS AMISTADES': 'MY FRIENDS', 'Nombre:': 'Name:', 'Correo:': 'Email:',
        'Enlazar': 'Link', 'Dejar amistad': 'Unfriend', 'rechazar': 'Decline', 'Solicitud de compartir': 'Share request',
        'Dispositivo:': 'Device:', 'Conectado': 'Connected', 'Desconectado': 'Disconnected', 'Recibidos:': 'Received:',
        'Mensajes e interacciones': 'Messages and interactions', 'AÃ±adir Momento': 'Add step', 'AÃ±adir momento': 'Add step',
        'RECHAZAR': 'DECLINE', 'Siguiente': 'Next', 'Anterior': 'Previous', 'Ver mÃ¡s': 'See more', 'Ver menos': 'See less',
        'InformaciÃ³n de la Raspberry': 'Raspberry information', 'Registrar Raspberry': 'Register Raspberry Pi',
        'Encontrar Hash': 'Find hash', 'Hash raspberry': 'Raspberry hash', 'Nombre Raspberry': 'Raspberry name',
        'DescripciÃ³n de la propuesta': 'Proposal description', 'Cancelar solicitud': 'Cancel request',
        'Apagado enviado correctamente': 'Shutdown command sent successfully', 'Reinicio enviado correctamente': 'Restart command sent successfully',
        'Error al enviar comando': 'Could not send command', 'La sesiÃ³n expirÃ³. Inicie sesiÃ³n nuevamente.': 'Your session expired. Please sign in again.',
        'Algo saliÃ³ mal:': 'Something went wrong:', 'Error al cargar los datos': 'Could not load the data',
        'Solicitudes recibidas': 'Received requests', 'Secuencia': 'Sequence', 'Colecciones': 'Collections',
        'ID': 'ID', 'id': 'ID', 'Acciones': 'Actions', 'nombre coleccion': 'Collection name', 'raspberry': 'Raspberry Pi',
        'Cambiando idioma…': 'Changing language…',
        'nombre_raspberry': 'Raspberry name', 'Descripción': 'Description', 'status': 'Status', 'icono': 'Icon',
        'nombresecuencia': 'Sequence name', 'descripcionsecuencia': 'Sequence description', 'Correlativo': 'Record number',
        'Fecha Adjunto': 'Attachment date', 'Fecha Estimada': 'Estimated date', 'Nombre del archivo': 'File name',
        'Cotización': 'Quote', 'Nombre': 'Name', 'Cantidad': 'Quantity', 'Monto presupuestado': 'Budgeted amount',
        'Observaciones': 'Notes', 'Actiones': 'Actions', 'Telefono': 'Phone', 'tipo de usuario': 'User type',
        'Usuario': 'User', 'Colección': 'Collection', 'Fecha': 'Date', 'Tipo': 'Type',
        'Ver Coleccion': 'View Collection', 'Compartir colección': 'Share collection',
        'Selecciona un color': 'Select a color', 'Selecciona Raspberry (hash)': 'Select Raspberry Pi (hash)',
        'nombre_coleccion': 'Collection name', 'Informacion de la Raspberry': 'Raspberry Pi information',
        'Editar Registro': 'Edit Record', 'Deshabilitar Raspberry': 'Disable Raspberry Pi',
        'No puede ir vacio.': 'This field cannot be empty.', 'No se pudo copiar el hash': 'Could not copy the hash',
        'Ver registro': 'View record', 'Nuevo Registro': 'New Record', 'Editar registro': 'Edit record',
        'Eliminar registro': 'Delete record', '¿Seguro que desea eliminar este registro?': 'Are you sure you want to delete this record?',
        'Permisos': 'Permissions', 'Matricula': 'Registration number', 'Apellido': 'Last name', 'Nivel': 'Level', 'Email': 'Email',
        '¿Aceptar la solicitud de compartir la colección "{coleccion}" de {usuario}?': 'Accept the request to share the collection "{coleccion}" from {usuario}?',
        '¿Rechazar la solicitud de compartir la colección "{coleccion}" de {usuario}?': 'Decline the request to share the collection "{coleccion}" from {usuario}?',
        '¿Seguro que deseas dejar la amistad con {usuario}?': 'Are you sure you want to end your friendship with {usuario}?',
        'No se pudieron cargar los usuarios': 'Could not load users',
        'No se pudieron cargar las colecciones': 'Could not load collections',
        'No se pudo eliminar la amistad': 'Could not remove the friendship',
        'No se pudo registrar la Raspberry': 'Could not register the Raspberry Pi',
        'No se pudo actualizar la Raspberry': 'Could not update the Raspberry Pi',
        'No se pudo deshabilitar la Raspberry': 'Could not disable the Raspberry Pi',
        'No se pudo validar el hash de la Raspberry': 'Could not validate the Raspberry Pi hash',
        'Error al enviar la solicitud de compartir': 'Could not send the sharing request',
        'Solicitud de compartir enviada correctamente': 'Sharing request sent successfully',
        'Sesión cerrada correctamente': 'You have signed out successfully',
    },
    es: {},
    ja: {
        'Solicitudes de Compartir Colecciones Recibidas': '受信したコレクション共有リクエスト',
        'No hay solicitudes de compartir': '共有リクエストはありません',
        'Credenciales incorrectas': 'ユーザー名またはパスワードが正しくありません',
        'Error de conexión': '接続エラー',
        'Error en la petición al servidor': 'サーバーへのリクエストに失敗しました',
        'Solicitud enviada correctamente': 'リクエストを送信しました',
        'Error al enviar la solicitud': 'リクエストを送信できませんでした',
        'Solicitud aceptada correctamente': 'リクエストを承認しました',
        'Error al aceptar la solicitud': 'リクエストを承認できませんでした',
        'Error al cargar las solicitudes': 'リクエストを読み込めませんでした',
        'Error al cargar las amistades.': '友達一覧を読み込めませんでした',
        'Amistad eliminada correctamente': '友達を削除しました',
        'El registro se guardo Exitosamente': 'レコードを保存しました',
        'No se pudo guardar la información': '情報を保存できませんでした',
        'Denunciar': '報告', 'Lanzador de botones': 'ボタンランチャー',
        'EDICION DE SECUENCIAS DEL BOTON': 'ボタンシーケンスの編集',
        'CREACION DE BOTONES': 'ボタンの作成',
        'Al seleccionar un icono, no aparecera el texto del boton.': 'アイコンを選択すると、ボタンのテキストは表示されません。',
        'Colecciones': 'コレクション', 'Solicitudes Colecciones': 'コレクションのリクエスト', 'Raspberrys': 'Raspberry Pi',
        'Buscar Usuarios': 'ユーザーを検索', 'Solicitudes Amistad': '友達リクエスト', 'Amistades': '友達',
        'OPCIONES': 'オプション', 'Historial Secuencias': 'シーケンス履歴', 'Perfil': 'プロフィール',
        'Terminos y condiciones': '利用規約', 'Select de idiomas aqui': '言語', 'Cerrar sesión': 'ログアウト',
        'Algo salio mal': '問題が発生しました', 'Escriba su correo': 'メールアドレスを入力', 'Entre su contraseña': 'パスワードを入力',
        'Entrar': 'ログイン', 'Registrar': '登録', 'Recuperar': 'アカウントを復元', 'Bienvenido': 'ようこそ',
        'Enviar': '送信', 'Cancelar': 'キャンセル', 'Guardar': '保存', 'Limpiar': 'クリア', 'Cerrar': '閉じる',
        'Regresar': '戻る', 'Nombre': '名前', 'Correo': 'メールアドレス', 'Descripcion': '説明',
        'Mis amigos': '友達', 'Solicitudes de Amistad': '友達リクエスト', 'Cargando...': '読み込み中…',
        'Por el momento no hay informacion': '現在、情報はありません', 'Iconos para el botón': 'ボタンのアイコン',
        'nueva escena': '新しいシーン', 'Eliminar': '削除', 'Duplicar': '複製', 'Idioma': '言語',
        'Inglés': '英語', 'Español': 'スペイン語', 'Japonés': '日本語', 'Ruso': 'ロシア語', 'Aceptar': '承認', 'Rechazar': '拒否',
        'Nuevo': '新規', 'nuevo': '新規', 'nombre coleccion': 'コレクション名', 'idraspberry': 'Raspberry ID',
        'Cargando datos...': 'データを読み込み中…', 'Sin raspberry aun.': 'Raspberry Pi はまだありません。',
        'nombre_raspberry': 'Raspberry 名', 'Descripcion de la Solicitud': 'リクエストの説明',
        'Nombre de Raspberry:': 'Raspberry 名：', 'Hash del dispositivo:': 'デバイスのハッシュ：',
        '¿Desea deshabilitar este registro?': 'このレコードを無効にしますか？', 'Este proceso no se puede desahacer.': 'この操作は元に戻せません。',
        'Solicitud actualizada correctamente': 'リクエストを更新しました', 'Registro deshabilitado correctamente': 'レコードを無効にしました',
        'Hash copiado.': 'ハッシュをコピーしました。', 'Historial Servos': 'サーボ履歴', 'Buscar usuarios': 'ユーザーを検索',
        '¿Eliminar escena completa con todos sus momentos?': 'シーンとすべてのステップを削除しますか？', '¿Eliminar servo?': 'サーボを削除しますか？',
        '¿Apagar esta Raspberry?': 'この Raspberry Pi をシャットダウンしますか？', '¿Reiniciar esta Raspberry?': 'この Raspberry Pi を再起動しますか？',
        '¿Estás seguro de desactivar esta coleccion?': 'このコレクションを無効にしますか？',
        'Nueva Coleccion': '新しいコレクション', 'Descripción': '説明', 'Descripcion:': '説明：',
        'Nueva Amistad': '新しい友達', 'Solicitudes de amistad': '友達リクエスト', 'No hay solicitudes': 'リクエストはありません',
        'No se encontraron resultados': '検索結果はありません', 'Colección': 'コレクション', 'Coleccion': 'コレクション',
        'Nombre de la secuencia': 'シーケンス名', 'Título': 'タイトル', 'Titulo': 'タイトル', 'Versión': 'バージョン', 'Version': 'バージョン',
        'Cambiar contraseña': 'パスワードを変更', 'Nueva contraseña': '新しいパスワード', 'Repita contraseña': 'パスワードを再入力',
        'Recuperación de password': 'パスワードの再設定', 'Confirmar': '確認', 'Siguiente': '次へ',
        'Contraseña actualizada correctamente': 'パスワードを更新しました', 'Página': 'ページ',
        'MI PERFIL': 'プロフィール', 'MIS AMISTADES': '友達', 'Nombre:': '名前：', 'Correo:': 'メールアドレス：',
        'Enlazar': 'リンク', 'Dejar amistad': '友達を解除', 'rechazar': '拒否', 'Solicitud de compartir': '共有リクエスト',
        'Dispositivo:': 'デバイス：', 'Conectado': '接続中', 'Desconectado': '未接続', 'Recibidos:': '受信数：',
        'Mensajes e interacciones': 'メッセージと操作', 'Añadir Momento': 'ステップを追加', 'Añadir momento': 'ステップを追加',
        'Información de la Raspberry': 'Raspberry の情報', 'Registrar Raspberry': 'Raspberry Pi を登録',
        'Encontrar Hash': 'ハッシュを検索', 'Hash raspberry': 'Raspberry ハッシュ', 'Nombre Raspberry': 'Raspberry 名',
        'Apagado enviado correctamente': 'シャットダウンコマンドを送信しました', 'Reinicio enviado correctamente': '再起動コマンドを送信しました',
        'Error al enviar comando': 'コマンドを送信できませんでした', 'Solicitudes recibidas': '受信したリクエスト',
        'Secuencia': 'シーケンス', 'Colecciones': 'コレクション',
        'ID': 'ID', 'id': 'ID', 'Acciones': '操作', 'nombre coleccion': 'コレクション名', 'raspberry': 'Raspberry Pi',
        'Cambiando idioma…': '言語を変更しています…',
        'nombre_raspberry': 'Raspberry 名', 'Descripción': '説明', 'status': 'ステータス', 'icono': 'アイコン',
        'nombresecuencia': 'シーケンス名', 'descripcionsecuencia': 'シーケンスの説明', 'Correlativo': '番号',
        'Fecha Adjunto': '添付日', 'Fecha Estimada': '予定日', 'Nombre del archivo': 'ファイル名',
        'Cotización': '見積もり', 'Nombre': '名前', 'Cantidad': '数量', 'Monto presupuestado': '予算額',
        'Observaciones': '備考', 'Actiones': '操作', 'Telefono': '電話番号', 'tipo de usuario': 'ユーザー種別',
        'Usuario': 'ユーザー', 'Colección': 'コレクション', 'Fecha': '日付', 'Tipo': '種類',
        'Ver Coleccion': 'コレクションを表示', 'Compartir colección': 'コレクションを共有',
        'Selecciona un color': '色を選択', 'Selecciona Raspberry (hash)': 'Raspberry Pi（ハッシュ）を選択',
        'nombre_coleccion': 'コレクション名', 'Informacion de la Raspberry': 'Raspberry Pi の情報',
        'Editar Registro': 'レコードを編集', 'Deshabilitar Raspberry': 'Raspberry Pi を無効にする',
        'No puede ir vacio.': 'この項目は空欄にできません。', 'No se pudo copiar el hash': 'ハッシュをコピーできませんでした',
        'Ver registro': 'レコードを表示', 'Nuevo Registro': '新しいレコード', 'Editar registro': 'レコードを編集',
        'Eliminar registro': 'レコードを削除', '¿Seguro que desea eliminar este registro?': 'このレコードを削除してもよろしいですか？',
        'Permisos': '権限', 'Matricula': '登録番号', 'Apellido': '姓', 'Nivel': 'レベル', 'Email': 'メールアドレス',
        '¿Aceptar la solicitud de compartir la colección "{coleccion}" de {usuario}?': '{usuario} からのコレクション「{coleccion}」共有リクエストを承認しますか？',
        '¿Rechazar la solicitud de compartir la colección "{coleccion}" de {usuario}?': '{usuario} からのコレクション「{coleccion}」共有リクエストを拒否しますか？',
        '¿Seguro que deseas dejar la amistad con {usuario}?': '{usuario} との友達関係を解除してもよろしいですか？',
        'Error en la petición': 'リクエストに失敗しました',
        'No se pudieron cargar los usuarios': 'ユーザーを読み込めませんでした',
        'No se pudieron cargar las colecciones': 'コレクションを読み込めませんでした',
        'No se pudo eliminar la amistad': '友達関係を解除できませんでした',
        'No se pudo registrar la Raspberry': 'Raspberry Pi を登録できませんでした',
        'No se pudo actualizar la Raspberry': 'Raspberry Pi を更新できませんでした',
        'No se pudo deshabilitar la Raspberry': 'Raspberry Pi を無効にできませんでした',
        'No se pudo validar el hash de la Raspberry': 'Raspberry Pi のハッシュを確認できませんでした',
        'Error al enviar la solicitud de compartir': '共有リクエストを送信できませんでした',
        'Solicitud de compartir enviada correctamente': '共有リクエストを送信しました',
        'Sesión cerrada correctamente': 'ログアウトしました',
        'EDITAR INFORMACION DE PERFIL': 'プロフィール情報を編集',
        'Imagen de Perfil': 'プロフィール画像',
        'IMAGEN DE PERFIL': 'プロフィール画像',
        'Cambiar Contraseña': 'パスワードを変更',
        'Nueva Contraseña': '新しいパスワード',
        'Repita Contraseña': 'パスワードを再入力',
        'Recuperacion de password': 'パスワードの再設定',
        'Digite una nueva contraseña.': '新しいパスワードを入力してください。',
        'La imagen se actualizo Exitosamente': 'プロフィール画像を更新しました',
        'Seleccione una imagen primero': '先に画像を選択してください',
        'Las contraseñas no coinciden': 'パスワードが一致しません',
    },
};

dictionaries.en = { ...dictionaries.en, Idioma: en.language, Inglés: en.english, Español: en.spanish, Japonés: en.japanese };
dictionaries.es = { ...dictionaries.es, Idioma: es.language, Inglés: es.english, Español: es.spanish, Japonés: es.japanese };
dictionaries.ja = { ...dictionaries.ja, Idioma: ja.language, Inglés: ja.english, Español: ja.spanish, Japonés: ja.japanese };
dictionaries.ru = { ...ru, Idioma: ru.language, Inglés: ru.english, Español: ru.spanish, Japonés: ru.japanese, Ruso: ru.russian };

dictionaries.es = Object.fromEntries(Object.keys(dictionaries.en).map((text) => [text, text]));

const idiomaGuardado = localStorage.getItem('servosystem-locale');
const idiomaInicial = idiomasDisponibles.some(({ value }) => value === idiomaGuardado)
    ? idiomaGuardado
    : idiomaPredeterminado;
if (idiomaGuardado && idiomaInicial !== idiomaGuardado) {
    localStorage.setItem('servosystem-locale', idiomaPredeterminado);
}

export const localeState = { current: idiomaInicial };

export function getLocale() {
    if (localStorage.getItem('typesession') === 'admin') return 'es';
    return localeState.current;
}

export function setLocale(value) {
    if (localStorage.getItem('typesession') === 'admin') {
        localeState.current = 'es';
        return;
    }
    localeState.current = idiomasDisponibles.some(({ value: codigo }) => codigo === value) ? value : idiomaPredeterminado;
    localStorage.setItem('servosystem-locale', localeState.current);
    scheduleTranslateDocument();
}

export function endLocaleSession() {
    localeState.current = idiomaPredeterminado;
}

export function translateText(value, params = {}) {
    const locale = getLocale();
    if (!value) return value;
    for (const spanish of Object.keys(dictionaries.es)) {
        const english = dictionaries.en[spanish];
        const japanese = dictionaries.ja[spanish];
        const russian = dictionaries.ru[spanish];
        if (value === spanish || value === english || value === japanese || value === russian) {
            const translated = dictionaries[locale][spanish] || value;
            return Object.entries(params).reduce(
                (text, [key, replacement]) => text.split(`{${key}}`).join(String(replacement ?? '')),
                translated
            );
        }
    }
    return value;
}

export function translateDocument() {
    if (localStorage.getItem('typesession') === 'admin' || location.pathname === '/loginadmin') return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script, style, code, pre, textarea, [translate="no"]')) continue;
        const translated = translateText(node.nodeValue.trim());
        if (translated !== node.nodeValue.trim()) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), translated);
    }
    document.querySelectorAll('[placeholder], [title], [aria-label]').forEach((element) => {
        if (element.closest('[translate="no"]')) return;
        ['placeholder', 'title', 'aria-label'].forEach((attribute) => {
            if (element.hasAttribute(attribute)) element.setAttribute(attribute, translateText(element.getAttribute(attribute)));
        });
    });
}

let observer;
let translationFrame = null;

function scheduleTranslateDocument() {
    if (translationFrame !== null) return;
    translationFrame = window.requestAnimationFrame(() => {
        translationFrame = null;
        translateDocument();
    });
}

export function observeTranslations() {
    if (observer || !document.body) return;
    observer = new MutationObserver(scheduleTranslateDocument);
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    scheduleTranslateDocument();
}
